import styled from 'styled-components'

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0 0 32px 0;
  background-color: #f4f4f4;
`

export const SectionName = styled.h2`
  font-size: 1.4rem;
  font-weight: 700;
  width: fit-content;
  padding-right: 1rem;
  margin-right: 1rem;
  border-right: 1px solid #EBEBEB;
`